export default __webpack_public_path__ + "static/media/vtc-banner.eee05fbf.jpg";